import { CtaLink } from "../components/common/CtaLink";
import { usePageTitle } from "../lib/usePageTitle";

export default function NotFoundPage() {
  usePageTitle("Page not found", { noindex: true });
  return (
    <section data-testid="not-found-page" className="container-x flex min-h-[60vh] flex-col items-start justify-center py-24">
      <p className="label-mono text-[#FF5500]">404</p>
      <h1 className="mt-4 font-display text-4xl font-extrabold uppercase text-slate-50 sm:text-5xl">This road doesn't go anywhere.</h1>
      <p className="mt-4 text-slate-400">The page you're looking for doesn't exist.</p>
      <CtaLink to="/" testId="not-found-home" className="mt-10">Back to home</CtaLink>
    </section>
  );
}
